import * as React from "react";
import { connect } from "react-redux";

import { Item, Button, Segment, Loader } from "semantic-ui-react";

import { NonFixedLengthChildAppointment } from "@teamprevent/common/calendar/models";
import { TaskTypes } from "@teamprevent/common/task/taskActions/models";

import { ApplicationState } from "../../models";
import { WarningIndicator } from "../../../crud/employeeRecord/components/details/WarningIndicator";
import { useHealthSurveillanceQuestionnaire } from "../../../healthSurveillance/hooks";
import { useOhCaseDetailsModel } from "../../../crud/ohCase";

import { ViewEmployeeRecordButton } from "./ViewEmployeeRecordButton";
import { ViewEmployeeCaseButton } from "./ViewEmployeeCaseButton";

import { Link } from "redux-little-router";

interface Props {
    appointment: NonFixedLengthChildAppointment;
    path: string;
    clinicId: string;
}

const MobileClinicAppointmentActionsUnconnected: React.FC<Props> = (props) => {
    const {
        questionnaire,
        isLoading: isQuestionnaireLoading
    } = useHealthSurveillanceQuestionnaire({ clinicId: props.clinicId, appointmentId: props.appointment.id });

    const customerId = props.appointment.customer.id;
    const employeeRecordId = props.appointment.employee.id;
    const ohCaseId = props.appointment.ohCaseId;
    const { ohCase, isLoading: isOhCaseLoading, isLoaded: isQuestionnaireLoaded } = useOhCaseDetailsModel({ ohCaseId, customerId });

    if (isOhCaseLoading || isQuestionnaireLoaded !== true) {
        return <Loader active />;
    }

    const healthSurveillanceConsultationTask = ohCase.tasks.find(t => t.type === TaskTypes.HealthSurveillanceConsultationTask && t.cancelled !== true);
    const isConsultationCompleted = healthSurveillanceConsultationTask?.completed;
    const repeatMedicalConsultationTasks = ohCase.tasks.filter(t => t.type === TaskTypes.RepeatMedicalConsultationTask && t.cancelled !== true) ?? [];

    return (
        <Segment>
            <Item>
                <Item.Content>
                    <h3 className="item-header">{props.appointment.employee.name}</h3>
                    <WarningIndicator notes={ohCase.criticalNotes} />
                </Item.Content>
                <Item.Extra>
                    <Segment clearing>
                        <ViewEmployeeRecordButton customerId={customerId} employeeRecordId={employeeRecordId} />
                        <ViewEmployeeCaseButton customerId={customerId} employeeRecordId={employeeRecordId} ohCaseId={ohCase.id} />
                        <Button
                            as={Link}
                            href={`${props.path}/appointment/${props.appointment.id}/questionnaire`}
                            loading={isQuestionnaireLoading}
                            disabled={isQuestionnaireLoading}
                            floated="right"
                        >
                            {questionnaire?.data ? "View Questionnaire" : "Complete Questionnaire"}
                        </Button>
                        {healthSurveillanceConsultationTask &&
                            <Button
                                as={Link}
                                href={`${props.path}/appointment/${props.appointment.id}/consultation`}
                                floated="right"
                            >
                                {isConsultationCompleted ? "View Consultation" : "Conduct Consultation"}
                            </Button>}
                        {repeatMedicalConsultationTasks.map(task =>
                            (<Button
                                key={task.id}
                                as={Link}
                                href={`${props.path}/appointment/${props.appointment.id}/consultation/${task.id}/repeatMedical`}
                                floated="right"
                            >
                                {task.completed ? "View Repeat Medical Consultation" : "Conduct Repeat Medical Consultation"}
                            </Button>)
                        )}
                    </Segment>
                </Item.Extra>
            </Item>
        </Segment>
    );
};

const mapStateToProps = (state: ApplicationState) => ({
    path: state.router.pathname
});

export const MobileClinicAppointmentActions = connect(mapStateToProps)(MobileClinicAppointmentActionsUnconnected);
